module.exports = __webpack_public_path__ + "assets/img/img233.90bfa423.png";